import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { ImageInterface } from 'common/types/entities/ImageInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createImage(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): ImageInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Image, parentId, masterBlockId),
    alignSelf: 'center',
  }
}
